import axios from 'axios';
import { GachaTicketWallet } from 'types/gacha-tickets';

export const getGachaTickets = (signal?: AbortSignal): Promise<GachaTicketWallet> =>
  axios.get('male/gacha-tickets', { signal }).then((response) => response.data);
